module.exports = __webpack_public_path__ + "static/media/foam.f999604c.png";